import { Asset } from '../..';
import { directTreasuryOffersQueryUpdated } from '../../../../../../../../store/product/selectors';

import { DirectTreasuryListItem } from './ListItem';
import { ListLoadingItem } from './ListLoadingItem';

export const DirectTreasuryAsset = () => {
  return (
    <Asset
      productsQuery={directTreasuryOffersQueryUpdated}
      ProductItem={DirectTreasuryListItem}
      ProductItemLoading={ListLoadingItem}
      keySelector="productIdNormalized"
    />
  );
};
